export const formatDate = post_date => {
    const months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ]

    let date = new Date(post_date)
    return months[date.getMonth()] + ' ' + date.getDate() + ', ' + date.getFullYear()
}
